/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Restart_NowInputs */

const en_mobile_ota_restart_now = /** @type {(inputs: Mobile_Ota_Restart_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart to apply update`)
};

const es_mobile_ota_restart_now = /** @type {(inputs: Mobile_Ota_Restart_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar para aplicar`)
};

/**
* | output |
* | --- |
* | "Restart to apply update" |
*
* @param {Mobile_Ota_Restart_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_restart_now = /** @type {((inputs?: Mobile_Ota_Restart_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Restart_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_restart_now(inputs)
	return en_mobile_ota_restart_now(inputs)
});